// React Dependencies
import React from 'react';

// Extenral Dependencies
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Backdrop, IconButton } from '@material-ui/core';
import { Link } from 'react-router-dom';

// Internal Dependencies
import { toast } from 'react-toastify';
import layoutAction from '../../actions/layout';
import Colours from '../../styles/colours';
import { AllLoyaltyCardUrls, PageType, Url } from '../../common/constants';
import Icons from '../Common/Icons';
import AppMenuSidebarMobile from './AppMenuSidebarMobile';
import { IsEmpty, IsAdminOnly, IsAdminOrContributor, IsTrue, IsPhotographerPage } from '../../common/checks';
import ApiService from '../../services/apiService';
import MText from '../Common/MText';
import { logError } from '../../common/errorUtil';

class PageSideBarMobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isGiftEnabled: false,
      prefixCode:    '',
    };
  }

  componentDidMount() {
    this.fetchPage();
  }

  onLoyaltyProgramLinkClickedHandler = () => {
    this.props.dispatchLoyaltyProgramSideBarShow();
  }

  async fetchPage() {
    try {
      if (!IsEmpty(this.props.match?.params?.pageId)) {
        const page = await ApiService.getPageById(this.props.match.params.pageId);
        this.setState({ isGiftEnabled: IsTrue(page.giftEnabled), prefixCode: page.prefixCode });
      }
    } catch (err) {
      toast.error(err.message);
      logError(err);
    }
  }

  formatNavigateUrl = (urlTemplate) => {
    try {
      return String(urlTemplate).replace(':businessId', this.props.match.params.businessId).replace(':pageId', this.props.pageSelected.id);
    } catch (err) {
      toast.error(err.message);
    }
  }

  render() {
    const notPageExist =  IsEmpty(this.props.match.params?.pageId) && IsEmpty(this.props.pageSelected);
    const pageType = this.props.pageSelected?.pageType;

    return (
      <div
        className="d-flex"
        style={{
          ...this.props.style,
          width:           notPageExist ? '80px' : '300px',
          backgroundColor: Colours.White,
        }}
      >
        <div className="d-flex">
          <AppMenuSidebarMobile match={this.props.match} dispatchSideBarHide={this.props.dispatchSideBarHide} />
        </div>

        {
          !IsEmpty(this.props.pageSelected)
            && (
              <>
                <div
                  className="d-flex flex-column pt-2"
                  style={{ width: '100%', height: 60 }}
                >
                  <div className="d-flex flex-row justify-content-end align-items-center pl-1">
                    <IconButton onClick={this.props.onLinkClicked}>
                      <Icons.Cross colour={Colours.Gray2} fontSize="1rem" />
                    </IconButton>
                  </div>

                  <div
                    className="d-flex mt-4"
                    style={{
                      ...this.props.style,
                      width:           '100%',
                      flexDirection:   'column',
                      justifyContent:  'flex-start',
                      alignItems:      'flex-start',
                      backgroundColor: Colours.White,
                    }}
                  >
                    <div className="sub-menu-item">
                      <MText
                        variant="body1"
                        colour={Colours.Black}
                        text={this.props.pageSelected.name}
                        semibold
                        size={15}
                      />
                    </div>

                    {/* <MenuButton
                      text="Analytics"
                      to={Url.Analytics.replace(':pageId', this.props.match.params.pageId)}
                      onClick={this.props.onLinkClicked}
                    /> */}

                    {IsPhotographerPage(pageType) && (
                      <>
                        <div className="position-relative w-100">
                          <MenuButton
                            text="Photos"
                            bold={[Url.Albums, Url.Snapstyr, Url.SnapstyrAdd, Url.AlbumDetails, Url.AlbumPhotosAdd].includes(this.props.match.path)}
                            to={this.formatNavigateUrl(Url.Snapstyr)}
                            onClick={this.props.onLinkClicked}
                          />
                          <div className="ml-4">
                            <MenuButton
                              text="Snapstyr"
                              to={this.formatNavigateUrl(Url.Snapstyr)}
                              bold={[Url.Snapstyr, Url.SnapstyrAdd].includes(this.props.match.path)}
                              onClick={this.props.onLinkClicked}
                            />
                            <MenuButton
                              text="Albums"
                              to={this.formatNavigateUrl(Url.Albums)}
                              bold={[Url.Albums, Url.AlbumDetails, Url.AlbumPhotosAdd].includes(this.props.match.path)}
                              onClick={this.props.onLinkClicked}
                            />
                          </div>
                        </div>
                      </>
                    )}

                    <MenuButton
                      text="Posts"
                      to={this.formatNavigateUrl(Url.Posts)}
                      bold={[Url.Posts].includes(this.props.match.path)}
                      onClick={this.props.onLinkClicked}
                    />

                    {(pageType === PageType.AreaManagement) && (
                      <>
                        <MenuButton
                          text="Generic Highlight"
                          to={this.formatNavigateUrl(Url.GenericHighlight)}
                          onClick={this.props.onLinkClicked}
                        />

                        <MenuButton
                          text="Food Review Highlight"
                          to={this.formatNavigateUrl(Url.FoodReviewHighlight)}
                          onClick={this.props.onLinkClicked}
                        />

                        <MenuButton
                          text="Special Highlights"
                          to={this.formatNavigateUrl(`${Url.PageHighlightListing}?isSpecial=true`)}
                          onClick={this.props.onLinkClicked}
                        />

                        <MenuButton
                          text="Exclusive Highlights"
                          to={this.formatNavigateUrl(`${Url.PageHighlightListing}?isExclusive=true`)}
                          onClick={this.props.onLinkClicked}
                        />

                        <MenuButton
                          text="Geographic Boundary"
                          to={this.formatNavigateUrl(`${Url.GeographicBoundary}`)}
                          onClick={this.props.onLinkClicked}
                        />
                      </>
                    )}

                    <MenuButton
                      text="Information"
                      to={this.formatNavigateUrl(`${Url.PageInfo}`)}
                      bold={[Url.PageInfo].includes(this.props.match.path)}
                      onClick={this.props.onLinkClicked}
                    />

                    <MenuButton
                      text="Settings"
                      to={this.formatNavigateUrl(`${Url.Settings}`)}
                      bold={[Url.Settings].includes(this.props.match.path)}
                      onClick={this.props.onLinkClicked}
                    />

                    {([PageType.FNB, PageType.Retailer].includes(pageType)) && (
                      <MenuButton
                        text="Outlets"
                        to={this.formatNavigateUrl(`${Url.Outlets}`)}
                        bold={[Url.Outlets, Url.Outlet].includes(this.props.match.path)}
                        onClick={this.props.onLinkClicked}
                      />
                    )}

                    {
                      !IsPhotographerPage(pageType) && (
                        <>
                          { this.state.isGiftEnabled && (
                            <>
                              <MenuButton
                                text="Coupons & Vouchers"
                                to={this.formatNavigateUrl(`${Url.CouponsAndVouchers}`)}
                                bold={[Url.CouponsAndVouchers, Url.CouponVoucherTracking].includes(this.props.match.path)}
                                onClick={this.props.onLinkClicked}
                              />
                              <MenuButton
                                text="Loyalty Cards"
                                to={this.formatNavigateUrl(`${Url.LoyaltyCards}`)}
                                bold={AllLoyaltyCardUrls.includes(this.props.match.path)}
                                onClick={this.onLoyaltyProgramLinkClickedHandler}
                              />
                            </>
                          ) }

                          {
                            this.state.prefixCode && (
                              <MenuButton
                                text="Promo Codes"
                                to={this.formatNavigateUrl(`${Url.PromoCodes}`)}
                                bold={[Url.PromoCodes].includes(this.props.match.path)}
                                onClick={this.props.onLinkClicked}
                              />
                            )
                          }

                          {
                            IsAdminOrContributor(this.props.pageSelected.staffType) && (
                              <MenuButton
                                text="Ground Staffs"
                                to={this.formatNavigateUrl(`${Url.GroundStaffs}`)}
                                bold={[Url.GroundStaffs].includes(this.props.match.path)}
                                onClick={this.props.onLinkClicked}
                              />
                            )
                          }

                          {
                            IsAdminOnly(this.props.pageSelected.staffType) && (
                              <MenuButton
                                text="Access"
                                to={this.formatNavigateUrl(`${Url.Access}`)}
                                bold={[Url.Access].includes(this.props.match.path)}
                                onClick={this.props.onLinkClicked}
                              />
                            )
                          }

                          {
                            IsAdminOrContributor(this.props.pageSelected.staffType) && (
                              <MenuButton
                                text="Account"
                                to={this.formatNavigateUrl(`${Url.Account}`)}
                                bold={[Url.Account].includes(this.props.match.path)}
                                onClick={this.props.onLinkClicked}
                              />
                            )
                          }

                          {
                            IsAdminOrContributor(this.props.pageSelected.staffType) && (
                              <MenuButton
                                text="Business Profile"
                                to={this.formatNavigateUrl(`${Url.BusinessProfile}`)}
                                bold={[Url.BusinessProfile].includes(this.props.match.path)}
                                onClick={this.props.onLinkClicked}
                              />
                            )
                          }
                        </>
                      )
                    }
                  </div>
                </div>
              </>
            )
        }
        <Backdrop open onClick={this.props.onLinkClicked} />
      </div>
    );
  }
}

/* fontWeight: [Url.FoodReviewHighlight].includes(this.props.match.path) ? 'bold' : 'normal' */
const MenuButton = ({ bold, text, to, onClick }) => (
  <div className="position-relative w-100">
    <Button className="block p-0" style={{ borderRadius: 0 }} onClick={onClick}>
      {
        !IsEmpty(to) ? (
          <Link
            className="sub-menu-item"
            to={to}
          >
            <MText variant="body1" size={13} style={{ color: Colours.Black }} text={text} bold={bold} />
          </Link>
        ) : (
          <MText className="sub-menu-item" size={13} variant="body1" style={{ color: Colours.Black }} text={text} bold={bold} />
        )
      }
    </Button>
  </div>
);

MenuButton.propTypes = {
  bold:    PropTypes.bool,
  text:    PropTypes.string.isRequired,
  to:      PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

MenuButton.defaultProps = {
  bold: false,
  to:   undefined,
};

PageSideBarMobile.propTypes = {
  dispatchSideBarHide: PropTypes.func.isRequired,
  onLinkClicked:       PropTypes.func.isRequired,
  pageSelected:        PropTypes.shape({
    id:        PropTypes.number,
    name:      PropTypes.string,
    staffType: PropTypes.string,
    pageType:  PropTypes.string,
  }),
  style: PropTypes.shape({}),
  match: PropTypes.shape({
    params: PropTypes.shape({
      businessId: PropTypes.string,
      pageId:     PropTypes.string,
    }),
    path: PropTypes.string,
  }).isRequired,
  dispatchLoyaltyProgramSideBarShow: PropTypes.func.isRequired,
};

PageSideBarMobile.defaultProps = {
  style:        [],
  pageSelected: null,
};

const mapStateToProps = (state) => ({
  pageSelected: state.page.selected,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchSideBarHide:               () => layoutAction.sideBarHide(dispatch),
  dispatchLoyaltyProgramSideBarShow: () => layoutAction.loyaltyProgramSideBarShow(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PageSideBarMobile);
